<template>
  <v-container grid-list-xl class="pa-0">
    <v-row wrap>
      <v-col cols="6">
        <v-switch
          v-model="opsiSwitch"
          @change="setOpsiSwitch"
          :label="`Tampilkan data bahan verifikasi faktual perbaikan`"
        ></v-switch>
      </v-col>
      <v-col cols="12" class="pt-6">
        <v-card class="pa-4 blue lighten-5">
          <v-row>
            <v-col col="12" md="3"><v-icon color="success">mdi-smart-card</v-icon> Sudah memiliki KTA</v-col>
            <v-col col="12" md="3"><v-icon color="grey">mdi-timelapse</v-icon> KTA dalam proses</v-col>
<!--            <v-col col="12" md="3"> <v-icon color="orange">mdi-shield-account</v-icon>SIPOL</v-col>-->
            <v-col col="12" md="3"> <v-icon color="blue">mdi-account-check</v-icon> Terdaftar di KPU</v-col>
            <v-col col="12" md="3"> <v-icon color="purple">mdi-file-find</v-icon>SAMPLING</v-col>
            <v-col col="12" md="3"> <v-icon color="success">mdi-file-find</v-icon>Simulasi Verfak</v-col>
            <v-col col="12" md="3"> <v-icon color="success">mdi-account-check</v-icon>MS Verfak</v-col>
            <v-col col="12" md="3"> <v-icon color="red">mdi-account-check</v-icon>Daftar Verfak</v-col>
            <v-col col="12" md="3"> <v-icon color="red">mdi-file-find</v-icon>SAMPLING VERVAK PERBAIKAN</v-col>
            <v-col col="12" md="3"> <v-icon color="red">mdi-file-excel-box</v-icon>Hapus Sipol</v-col>

            <!--            <v-col col="12" md="3"> <v-icon color="orange">mdi-database-remove</v-icon>Tindak Lanjut Perbaikan</v-col>-->
<!--            <v-col col="12" md="3"> <v-icon color="teal">mdi-file-document</v-icon>Unggah Surat</v-col>-->
          </v-row>
<!--          <div class="caption pt-4 font-weight-bold">Status DPB</div>-->
<!--          <v-row>-->
<!--            <v-col col="12" md="3"> <v-icon color="success">mdi-shield-check</v-icon>Masuk DPB</v-col>-->
<!--            <v-col col="12" md="3"><v-icon color="red">mdi-shield-remove</v-icon>Belum Masuk DPB</v-col>-->
<!--            <v-col col="12" md="3"><v-icon color="grey">mdi-shield-alert-outline</v-icon>Belum Dicek</v-col>-->
<!--          </v-row>-->
        </v-card></v-col
      >
<!--      <v-col col="12" v-if="current_user.lingkup.tingkat == 1 || current_user.lingkup.tingkat == 2">-->
<!--        <div class="text-center">-->
<!--          <m-button dark color="error" icon="mdi-alert" depreed textButton="Unggah Salinan KTA SIPOL KPU" action="konfirmasi" @konfirmasi="konfirmasiUnggah"></m-button>-->
<!--        </div>-->
<!--      </v-col>-->
      <v-col cols="12">
        <m-card-list
          title="Data Anggota"
          search
          id-key
          refresh
          :add="!(current_user.peran && current_user.peran.id == 2)"
          unduhmulti
          @download="toDowload"
          @cetakExcell="cetakExcell"
          @cetakZIP="cetakZIP"
          @cetakZIPCADANGAN="cetakZIPCADANGAN"
          @cetakExcellKategori="cetakExcellKategori"
          @rekap="toCetakMasal"
          @rekapkota="rekapKota"
          @rekapkecamatan="rekapKecamatan"
          @refresh="load"
          @cetakKtpKtaFilter="cetakKtpKtaFilter"
          @cetakKtaFilter="cetakKtaFilter"
          @cetakKtaAll="cetakKtaAll"
          @cetakKtaByName="cetakKtaByName"
          @cetakKtaByKategori="cetakKtaByKategori"
          :generate="current_user && current_user.is_generate_all_kta == 1"
          @generate="generateNomorMasal"
          @validasi="validasi"
          @filter="filter"
          :items="items"
          :headers="headers"
          footerLabel="Anggota"
          @search="
            search => {
              textSearch = search;
              load();
            }
          "
          :page="page"
          @change:page="
            pg => {
              cp = pg;
              load();
            }
          "
          @add="add"
          footer
        >
          <template v-slot:filter>
            <FilterWarga @filter="filter" class="px-0" />
          </template>
          <template v-slot:items="{ props, item }">
            <v-container>
<!--              <v-row :class="item.is_lama == 1 ? 'green lighten-4' : item.is_lama == 0 && (item.is_daftar == 1 || item.is_daftar == 2) ? 'grey lighten-2' : ''">-->
              <v-row :class="item.is_ms_verfak == 1 ? 'green lighten-4' : ''">
                  <v-col cols="3" lg="1" md="1" sm="3">
                  <v-avatar size="70">
                    <v-img :src="item.foto ? item.foto.thumbnail : 'img/no-image.jpeg'" alt="avatar" />
                  </v-avatar>
                </v-col>
                <v-col cols="7" lg="9" md="9" sm="7">
                  <v-row>
                    <v-col class="py-0" cols="12" sm="4" md="4" lg="4">
                      <p class="caption my-0 py-1 grey--text align-left">
                        <!-- Nama -->
                      </p>
                      <p class="subtitle-1 font-weight-bold primary--text my-0 py-0 mt-n2">
                        {{ pVal(item, "nama") }}
                      </p>

                      <p class="caption my-0 py-0 black--text align-left">
                        NIK
                      </p>
                      <p class="font-weight-bold my-0 py-1 mt-n2">
                        {{ pVal(item, "nik") }}
                      </p>
                      <span
                        :class="
                          item.is_daftar === 1
                            ? 'caption my-0 py-0 mr-1 success--text'
                            : item.is_daftar === 2
                            ? 'caption my-0 py-0 mr-1 orange--text'
                            : 'caption my-0 py-0 mr-1 red--text'
                        "
                      >
                        {{ item.partai }}
                      </span>
                    </v-col>
                    <v-col class="py-0" cols="12" sm="4" md="4" lg="4">
                      <p class="caption my-0 py-0 grey--text align-left">
                        No KTA <span class="info--text">[{{ item.jumlah_terdaftar }}]</span>
                      </p>
                      <p class="subtitle-2 my-0 py-1 mt-n2">
                        {{ pVal(item, "nomer_anggota") }}
                      </p>
                      <v-tooltip v-if="item.is_proses_kta || item.is_generate_kta">
                        <template v-slot:activator="{ on }">
                          <v-btn x-small icon color="primary" v-on="on">
                            <v-icon v-on="on" :color="item.is_generate_kta && item.is_cetak ? 'red' : item.is_proses_kta ? 'blue' : item.is_generate_kta ? 'success' : 'grey'">{{
                              item.is_proses_kta ? "mdi-timelapse" : item.is_generate_kta ? "mdi-smart-card" : "mdi-smart-card"
                            }}</v-icon>
                          </v-btn>
                        </template>
                        <span>{{ item.is_proses_kta ? "Dalam proses generate KTA" : item.is_generate_kta ? "Sudah punya KTA" : "" }}</span>
                      </v-tooltip>

<!--                      <v-tooltip v-if="item.is_sipol">-->
<!--                        <template v-slot:activator="{ on }">-->
<!--                          <v-btn x-small icon color="primary" v-on="on">-->
<!--                            <v-icon v-on="on" :color="item.is_sipol ? 'orange' : 'grey'">mdi-shield-account</v-icon>-->
<!--                          </v-btn>-->
<!--                        </template>-->
<!--                        <span>{{ item.is_sipol ? "SIPOL" : "NON SIPOL" }}</span>-->
<!--                      </v-tooltip>-->

                      <v-tooltip v-if="item.is_daftar">
                        <template v-slot:activator="{ on }">
                          <v-btn x-small icon color="primary" v-on="on">
                            <v-icon v-on="on" :color="item.is_daftar ? 'blue' : 'grey'">mdi-account-check</v-icon>
                          </v-btn>
                        </template>
                        <span>{{ item.is_daftar ? "Terdaftar di KPU" : "Tidak terdaftar di KPU" }}</span>
                      </v-tooltip>

                      <v-tooltip>
                        <template v-slot:activator="{ on }">
                          <v-btn x-small icon color="primary" v-on="on">
                            <v-icon v-on="on" :color="item.validasi_lindungi_hak_mu == 1 ? 'success' : item.validasi_lindungi_hak_mu == 9 ? 'red' : 'grey'">{{
                              item.validasi_lindungi_hak_mu == 1 ? "mdi-shield-check" : item.validasi_lindungi_hak_mu == 9 ? "mdi-shield-remove" : "mdi-shield-alert-outline"
                            }}</v-icon>
                          </v-btn>
                        </template>
                        <span>{{
                          item.validasi_lindungi_hak_mu == 1 ? "Validasi KPU Valid" : item.validasi_lindungi_hak_mu == 9 ? "Validasi KPU Valid" : "Validasi KPU Belum dicek"
                        }}</span>
                      </v-tooltip>

                      <v-tooltip v-if="item.is_sampling">
                        <template v-slot:activator="{ on }">
                          <v-btn x-small icon color="primary" v-on="on">
                            <v-icon v-on="on" :color="item.is_sampling ? 'purple' : 'grey'">mdi-file-find</v-icon>
                          </v-btn>
                        </template>
                        <span>SAMPLING</span>
                      </v-tooltip>
                      <v-tooltip v-if="item.is_sampling_kpu">
                        <template v-slot:activator="{ on }">
                          <v-btn x-small icon color="primary" v-on="on">
                            <v-icon v-on="on" :color="item.is_sampling_kpu ? 'success' : 'grey'">mdi-file-find</v-icon>
                          </v-btn>
                        </template>
                        <span>Sampling KPU</span>
                      </v-tooltip>
                      <v-tooltip v-if="item.is_sample_verfak_perbaikan">
                        <template v-slot:activator="{ on }">
                          <v-btn x-small icon color="primary" v-on="on">
                            <v-icon v-on="on" :color="item.is_sample_verfak_perbaikan ? 'red' : 'grey'">mdi-file-find</v-icon>
                          </v-btn>
                        </template>
                        <span>Sampling Vervak PERBAIKAN</span>
                      </v-tooltip>
                      <v-tooltip v-if="item.is_ms_verfak">
                        <template v-slot:activator="{ on }">
                          <v-btn x-small icon color="primary" v-on="on">
                            <v-icon v-on="on" :color="item.is_ms_verfak ? 'success' : ''">mdi-account-check</v-icon>
                          </v-btn>
                        </template>
                        <span>MS Verfak</span>
                      </v-tooltip>

                      <v-tooltip v-if="item.is_daftar_verfak">
                        <template v-slot:activator="{ on }">
                          <v-btn x-small icon color="primary" v-on="on">
                            <v-icon v-on="on" :color="item.is_daftar_verfak ? 'red' : ''">mdi-account-check</v-icon>
                          </v-btn>
                        </template>
                        <span>Daftar Verfak</span>
                      </v-tooltip>

                      <v-tooltip v-if="item.is_hapus_sipol">
                        <template v-slot:activator="{ on }">
                          <v-btn x-small icon color="primary" v-on="on">
                            <v-icon v-on="on" :color="item.is_hapus_sipol ? 'red' : ''">mdi-file-excel-box</v-icon>
                          </v-btn>
                        </template>
                        <span>Hapus Sipol</span>
                      </v-tooltip>

<!--                      <v-tooltip v-if="item.is_bermasalah_2">-->
<!--                        <template v-slot:activator="{ on }">-->
<!--                          <v-btn x-small icon color="primary" v-on="on">-->
<!--                            <v-icon v-on="on" :color="item.is_bermasalah_2 ? 'orange' : 'grey'">mdi-database-remove</v-icon>-->
<!--                          </v-btn>-->
<!--                        </template>-->
<!--                        <span>Tindak Lanjut Perbaikan</span>-->
<!--                      </v-tooltip>-->
<!--                      <v-tooltip v-if="item.is_unggahsurat">-->
<!--                        <template v-slot:activator="{ on }">-->
<!--                          <v-btn x-small icon color="primary" v-on="on">-->
<!--                            <v-icon v-on="on" :color="item.is_unggahsurat ? 'teal' : 'grey'">mdi-file-document</v-icon>-->
<!--                          </v-btn>-->
<!--                        </template>-->
<!--                        <span>Unggah Surat</span>-->
<!--                      </v-tooltip>-->
                    </v-col>
                    <v-col class="py-0" cols="12" sm="2" md="2" lg="2">
                      <p class="caption my-0 py-0 grey--text">
                        Terakhir Validasi
                      </p>
                      {{ item.info_pemilu_update_at | toDT }}
                    </v-col>
                    <v-col class="py-0" cols="12" sm="2" md="2" lg="2">
                      <p class="caption my-0 py-0 grey--text">
                        Ditambahkan
                      </p>
                      {{ item.created_at | toDT }}
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="2" sm="2" md="1" lg="1">
                  <m-menu class="clearfix" style="float:right" :items="more_menu" :object="item" />
                </v-col>
              </v-row>
            </v-container>
            <v-divider />
          </template>
        </m-card-list>
      </v-col>
      <ChangeDlg ref="dlg" />
      <DetailDlg ref="detailDlg" />
      <PreviewDlg ref="previewDlg" />
      <CekDataDlg ref="cekDataDlg" />
      <PreviewCustomDlg ref="previewCustomDlg" />
      <PreviewNameDlg ref="previewNameDlg" />
      <PreviewKategoriDlg ref="previewKategoriDlg" />
      <PreviewZIPDlg ref="previewzipDlg" />
      <PreviewZIPCdg ref="previewzipCdg" />
      <UnggahDlg ref="unggahDlg" />
    </v-row>
  </v-container>
</template>

<script>
const lc = window.localStorage;
const TOKEN = "siapbbjatimtoken";
import ChangeDlg from "../../warga/components/Form.vue";
import UnggahDlg from "../../warga/components/Unggah.vue";
import DetailDlg from "../../warga/components/Detil.vue";
import PreviewDlg from "../../warga/components/Preview.vue";
import CekDataDlg from "../../warga/components/CekData.vue";
import PreviewCustomDlg from "../../warga/components/PreviewKTAKTP.vue";
import PreviewNameDlg from "../../warga/components/PreviewByName.vue";
import PreviewKategoriDlg from "../../warga/components/PreviewByKategori.vue";
import PreviewZIPDlg from "../../warga/components/PreviewZIP.vue";
import PreviewZIPCdg from "../../warga/components/PreviewZIPCADANGAN.vue";
import FilterWarga from "@/filter/FilterWarga.vue";

export default {
  components: {
    ChangeDlg,
    DetailDlg,
    PreviewDlg,
    FilterWarga,
    PreviewCustomDlg,
    PreviewNameDlg,
    PreviewKategoriDlg,
    CekDataDlg,
    PreviewZIPDlg,
    PreviewZIPCdg,
    UnggahDlg
  },
  data() {
    return {
      items: [],
      range: null,
      filtered: {
        propinsi_id: null,
        kota_id: null,
        kecamatan_id: null,
        kelurahan_id: null,
        status_kta: null,
        tanggal: null,
        is_lama: null,
      },
        opsiSwitch: false,
      itemMapels: [],
      peran: null,
      textSearch: null,
      page: null,
      cp: 1,
      headers: [
        { text: "", align: "left", value: "" },
        { text: "", align: "left", value: "" },
        { text: "", align: "left", value: "" },
        { text: "", sortable: false },
        { text: "", sortable: false }
      ],
      more_menu: [
        // eslint-disable-next-line
        {
          title: "Detil Anggota",
          click: (i, o) => this.getDetil(o)
        },
        {
          title: "Ubah",
          click: (i, o) => this.edit(o),
          check: (i, o) => o.nomer_anggota == "" && !(this.current_user.peran && this.current_user.peran.id == 2)
        },
        {
          title: "Ubah",
          click: (i, o) => this.edit(o),
          check: (i, o) =>
            o.nomer_anggota !== "" &&
            this.current_user &&
            (this.current_user.lingkup.tingkat == 1 || this.current_user.lingkup.tingkat == 2 || this.current_user.lingkup.tingkat == 3) &&
            !(this.current_user.peran && this.current_user.peran.id == 2)
        },
        {
          title: "Generate Nomor",
          click: (i, o) => this.generateNomor(o),
          check: (i, o) => !o.nomer_anggota
        },
        {
          title: "Set Cetak KTA",
          click: (i, o) => this.setCetakKTA(o, 1),
          check: (i, o) => o.is_cetak === 0
        },
        {
          title: "Batal Set Cetak KTA",
          click: (i, o) => this.setCetakKTA(o, 0),
          check: (i, o) => o.is_cetak === 1
        },
        // {
        //   title: "Cetak PDF",
        //   click: (i, o) => this.cetakKTA(o),
        //   check: (i, o) => o.nomer_anggota != ""
        // },
        {
          title: "Preview KTA",
          click: (i, o) => this.previewKTA(o)
        },
        // {
        //   title: "Set SIPOL",
        //   click: (i, o) => this.setSipol(o, 1),
        //   check: (i, o) => o.is_sipol === 0
        // },
        // {
        //   title: "Set Non Sipol",
        //   click: (i, o) => this.setSipol(o, 0),
        //   check: (i, o) => o.is_sipol === 1
        // },
        // {
        //   title: "Set Sampling",
        //   click: (i, o) => this.setSampling(o, 1),
        //   check: (i, o) => o.is_sampling === 0
        // },
        // {
        //   title: "Set Batal Sampling",
        //   click: (i, o) => this.setSampling(o, 0),
        //   check: (i, o) => o.is_sampling === 1
        // },
        // {
        //   title: "Set Status Validasi Valid",
        //   click: (i, o) => this.setValidasi(o, 1),
        //   check: (i, o) => o.validasi_lindungi_hak_mu === 0
        // },
        // {
        //   title: "Surat Pernyataan",
        //   click: (i, o) => this.setValidasi(o, 9),
        //   check: (i, o) => o.validasi_lindungi_hak_mu === 0
        // },
        {
          title: "Validasi",
          click: (i, o) => this.setValidasis(o, 9)
        },
        {
          title: "Set MS Verfak",
          click: (i, o) => this.setVerfak(o, 1),
          check: (i, o) => o.is_ms_verfak === 0
        },
        {
          title: "Set BMS Verfak",
          click: (i, o) => this.setVerfak(o, 0),
          check: (i, o) => o.is_ms_verfak === 1
        },
        {
          title: "Set Hapus Sipol",
          click: (i, o) => this.setHapusSipol(o, 1),
          check: (i, o) => o.is_hapus_sipol === 0
        },
        {
          title: "Batal Hapus Sipol",
          click: (i, o) => this.setHapusSipol(o, 0),
          check: (i, o) => o.is_hapus_sipol === 1
        },
        {
          title: "Set Daftar Verfak",
          click: (i, o) => this.setDaftarVerfak(o, 1),
          check: (i, o) => o.is_daftar_verfak === 0
        },
        {
          title: "Set Tidak Daftar Verfak",
          click: (i, o) => this.setDaftarVerfak(o, 0),
          check: (i, o) => o.is_daftar_verfak === 1
        },
        {
          title: "Hapus",
          click: (i, o) => this.hapus(o),
          check: (i, o) => this.current_user.is_super_admin || o.nomer_anggota == ""
        },
        {
          title: "Surat Tanggapan",
          click: (i, o) => this.downloadSP(o, "tanggapan_masyarakat")
        },
        {
          title: "Surat Bukan Anggota",
          click: (i, o) => this.downloadSP(o, "bukan_anggota")
        }
        // {
        //   title: "Surat Keanggotaan",
        //   click: (i, o) => this.downloadSP(o, "anggota")
        // },
        // {
        //   title: "Surat Usia dan Perkawinan",
        //   click: (i, o) => this.downloadSP(o, "usia")
        // },
        // {
        //   title: "Surat Pekerjaan",
        //   click: (i, o) => this.downloadSP(o, "asn")
        // },
        // {
        //   title: "Set Unggah Surat",
        //   click: (i, o) => this.setUnggahSurat(o, 1),
        //   check: (i, o) => o.is_unggahsurat == 0
        // },
        // {
        //   title: "Batal Set Unggah Surat",
        //   click: (i, o) => this.setUnggahSurat(o, 0),
        //   check: (i, o) => o.is_unggahsurat == 1
        // }
      ]
    };
  },
  mounted() {
    this.opsiSwitch = this.current_user.lingkup.is_hidden
    this.checkQuery();
    this.load();
  },
  methods: {
    checkQuery() {
      if (this.$route.params.id) {
        const id = this.$route.params.id;
        return this.$store
          .dispatch("warga/getDetil", id)
          .then(res => {
            this.$refs.dlg.open(res).then(() => {
              this.load();
            });
          })
          .catch(e => e);
      }
    },
    load() {
      return this.$store
        .dispatch("warga/get", {
          params: {
            page: this.cp,
            s: this.textSearch,
            role_id: this.peran,
            propinsi_id: this.filtered.propinsi_id,
            kota_id: this.filtered.kota_id,
            kecamatan_id: this.filtered.kecamatan_id,
            kelurahan_id: this.filtered.kelurahan_id,
            status_kta: this.filtered.status_kta,
            order: this.filtered.tanggal,
            is_sipol: this.filtered.sipol,
            kategori_id: this.filtered.kategori,
            is_sampling: this.filtered.is_sampling,
            validasi_lindungi_hak_mu: this.filtered.validasi_lindungi_hak_mu,
            is_daftar: this.filtered.is_daftar,
            jumlah_terdaftar: this.filtered.status_pendaftaran,
            is_sampling_kpu: this.filtered.is_sampling_kpu,
            is_sample_verfak_perbaikan: this.filtered.is_sample_verfak_perbaikan,
            is_ms_verfak: this.filtered.is_ms_verfak,
            is_hapus_sipol: this.filtered.is_hapus_sipol,
            is_daftar_verfak: this.filtered.is_daftar_verfak,
            is_vermin: this.filtered.is_vermin,
            is_unggahsurat: this.filtered.is_unggahsurat,
            is_lama: this.filtered.is_lama,
            is_bermasalah_2: this.filtered.is_bermasalah_2,
            is_cetak: this.filtered.is_cetak
          }
        })
        .then(res => {
          this.page = res;
          this.items = res.data;
        })
        .catch(e => e);
    },
    rekapKota() {
      var token = lc.getItem(TOKEN);
      return this.$store
        .dispatch("laporan/downloadRekapKota", {
          params: {
            access_token: token,
            propinsi_id: this.filtered.propinsi_id
          }
        })
        .catch(e => e);
    },
    cetakKtaFilter() {
      if (this.current_user.lingkup.tingkat == 1 && !this.filtered.kota_id) {
        this.$error("Pilih Propinsi dan Kota terlebih dahulu");
      } else if (this.current_user.lingkup.tingkat == 2 && !this.filtered.kota_id) {
        this.$error("Pilih Propinsi dan Kota terlebih dahulu");
      } else {
        var token = lc.getItem(TOKEN);
        return this.$store
          .dispatch("warga/cetakfilter", {
            params: {
              access_token: token,
              role_id: this.peran,
              propinsi_id: this.filtered.propinsi_id,
              kota_id: this.filtered.kota_id,
              kecamatan_id: this.filtered.kecamatan_id,
              kelurahan_id: this.filtered.kelurahan_id,
              status_kta: this.filtered.status_kta,
              is_sipol: this.filtered.sipol,
              kategori_id: this.filtered.kategori,
              is_sampling: this.filtered.is_sampling,
              validasi_lindungi_hak_mu: this.filtered.validasi_lindungi_hak_mu,
              is_daftar: this.filtered.is_daftar,
              jumlah_terdaftar: this.filtered.status_pendaftaran,
              is_sampling_kpu: this.filtered.is_sampling_kpu,
              is_sample_verfak_perbaikan: this.filtered.is_sample_verfak_perbaikan,
              is_ms_verfak: this.filtered.is_ms_verfak,
              is_hapus_sipol: this.filtered.is_hapus_sipol,
              is_daftar_verfak: this.filtered.is_daftar_verfak,
              is_vermin: this.filtered.is_vermin,
              is_unggahsurat: this.filtered.is_unggahsurat,
              is_lama: this.filtered.is_lama,
              is_cetak: this.filtered.is_cetak
            }
          })
          .catch(e => e);
      }
    },
    cetakKtpKtaFilter() {
      if (this.current_user.lingkup.tingkat == 1 && !this.filtered.kota_id) {
        this.$error("Pilih Propinsi dan Kota terlebih dahulu");
      } else if (this.current_user.lingkup.tingkat == 2 && !this.filtered.kota_id) {
        this.$error("Pilih Propinsi dan Kota terlebih dahulu");
      } else {
        var token = lc.getItem(TOKEN);
        return this.$store
          .dispatch("warga/cetakktpktafilter", {
            params: {
              access_token: token,
              role_id: this.peran,
              propinsi_id: this.filtered.propinsi_id,
              kota_id: this.filtered.kota_id,
              kecamatan_id: this.filtered.kecamatan_id,
              kelurahan_id: this.filtered.kelurahan_id,
              status_kta: this.filtered.status_kta,
              is_sipol: this.filtered.sipol,
              kategori_id: this.filtered.kategori,
              is_sampling: this.filtered.is_sampling,
              validasi_lindungi_hak_mu: this.filtered.validasi_lindungi_hak_mu,
              is_daftar: this.filtered.is_daftar,
              jumlah_terdaftar: this.filtered.status_pendaftaran,
              is_sampling_kpu: this.filtered.is_sampling_kpu,
              is_sample_verfak_perbaikan: this.filtered.is_sample_verfak_perbaikan,
              is_ms_verfak: this.filtered.is_ms_verfak,
              is_hapus_sipol: this.filtered.is_hapus_sipol,
              is_daftar_verfak: this.filtered.is_daftar_verfak,
              is_vermin: this.filtered.is_vermin,
              is_unggahsurat: this.filtered.is_unggahsurat,
              is_lama: this.filtered.is_lama,
              is_cetak: this.filtered.is_cetak
            }
          })
          .catch(e => e);
      }
    },
    cetakKtaAll() {
      if (this.current_user.lingkup.tingkat == 1 && !this.filtered.kota_id) {
        this.$error("Pilih Propinsi dan Kota terlebih dahulu");
      } else if (this.current_user.lingkup.tingkat == 2 && !this.filtered.kota_id) {
        this.$error("Pilih Propinsi dan Kota terlebih dahulu");
      } else {
        this.$confirm(
          `Masukkan range nomor data yang akan dicetak sesuai urutan data ?<br>
      `,
          {
            range: true
          }
        )
          .then(res => {
            this.range = res;
            this.$store
              .dispatch("warga/preview", { obj: res, kota_id: this.filtered.kota_id })
              .then(res => {
                this.previewCustom(res, this.range, this.filtered.kota_id);
              })
              .catch(e => e);
          })
          .catch(e => e);
      }
    },
    cetakKtaByName() {
      if (this.current_user.lingkup.tingkat == 1 && !this.filtered.kota_id) {
        this.$error("Pilih Propinsi dan Kota terlebih dahulu");
      } else if (this.current_user.lingkup.tingkat == 2 && !this.filtered.kota_id) {
        this.$error("Pilih Propinsi dan Kota terlebih dahulu");
      } else {
        this.$refs.previewNameDlg.open(this.filtered.kota_id).then(() => {
          this.load();
        });
      }
    },
    cetakKtaByKategori() {
      // if (this.current_user.lingkup.tingkat == 1 && !this.filtered.kota_id) {
      //   this.$error("Pilih Propinsi dan Kota terlebih dahulu");
      // } else if (this.current_user.lingkup.tingkat == 2 && !this.filtered.kota_id) {
      //   this.$error("Pilih Propinsi dan Kota terlebih dahulu");
      // } else {
      this.$refs.previewKategoriDlg.open(this.filtered).then(() => {
        this.load();
      });
      // }
    },
    setSipol(obj, status) {
      return this.$store
        .dispatch("warga/setsipol", {
          obj: obj,
          value: status
        })
        .then(() => this.load())
        .catch(e => e);
    },
    downloadSP(obj, jenissurat) {
      return this.$store
        .dispatch("warga/downloadSP", {
          obj: obj,
          params: {
            jenis_surat: jenissurat
          }
        })
        .catch(e => e);
    },
    setSampling(obj, status) {
      return this.$store
        .dispatch("warga/setsampling", {
          obj: obj,
          value: status
        })
        .then(() => this.load())
        .catch(e => e);
    },
    setVerfak(obj, status) {
      return this.$store
        .dispatch("warga/setverfak", {
          obj: obj,
          value: status
        })
        .then(() => this.load())
        .catch(e => e);
    },
    setHapusSipol(obj, status) {
      return this.$store
        .dispatch("warga/sethapussipol", {
          obj: obj,
          value: status
        })
        .then(() => this.load())
        .catch(e => e);
    },
    setDaftarVerfak(obj, status) {
      return this.$store
        .dispatch("warga/setdaftarverfak", {
          obj: obj,
          value: status
        })
        .then(() => this.load())
        .catch(e => e);
    },
    setCetakKTA(obj, status) {
      return this.$store
        .dispatch("warga/setcetakkta", {
          obj: obj,
          value: status
        })
        .then(() => this.load())
        .catch(e => e);
    },

    setUnggahSurat(obj, status) {
      return this.$store
        .dispatch("warga/setunggahsurat", {
          obj: obj,
          value: status
        })
        .then(() => this.load())
        .catch(e => e);
    },
    setValidasis(obj, status) {
      return this.$store
        .dispatch("warga/setvalidasis", {
          obj: obj,
          value: status
        })
        .then(() => this.load())
        .catch(e => e);
    },
    rekapKecamatan() {
      var token = lc.getItem(TOKEN);
      return this.$store
        .dispatch("laporan/downloadRekapKecamatan", {
          params: {
            access_token: token,
            propinsi_id: this.filtered.propinsi_id
          }
        })
        .catch(e => e);
    },
    generateNomor(obj) {
      this.loading = true;
      this.$confirm(`Setelah Pembuatan Nomer KTA data tidak bisa diubah lagi. Pastikan data sudah benar 100%<br>`)
        .then(() =>
          this.$store
            .dispatch("warga/generateNomor", obj)
            .then(res => {
              if (res.error) {
                this.$error(res.message);
                this.loading = false;
              } else {
                this.loading = false;
                this.$info("Generate nomor berhasil");
                this.load();
              }
            })
            .catch(e => e)
        )
        .catch(e => e);
    },
    generateNomorMasal() {
      if (this.filtered.kota_id) {
        this.loading = true;
        this.$confirm(`Sebelum melakukan Generate Nomor KTA, Sistem akan melakukan validasi data warga terlebih dahulu. Apakah Anda akan melanjutkan?`)
          .then(() =>
            this.$refs.cekDataDlg.open(this.filtered.kota_id).then(() => {
              this.load();
            })
          )
          .catch(e => e);
      } else {
        this.$error("Anda harus memilih Kota untuk unduh melakukan generate nomor KTA");
      }
    },
    validasi() {
      if (this.filtered.kota_id) {
        this.loading = true;
        this.$confirm(`Apakah Anda akan memvalidasi data berikut?`)
          .then(() => this.$store.dispatch("warga/validasi", { kota_id: this.filtered.kota_id }).catch(e => e))
          .catch(e => e);
      } else {
        this.$error("Anda harus memilih Kota terlebih dahulu");
      }
    },
    cetakExcell() {
      var token = lc.getItem(TOKEN);
      // if (this.filtered.kecamatan_id) {
      return this.$store
        .dispatch("warga/downloadXls", {
          params: {
            access_token: token,
            propinsi_id: this.filtered.propinsi_id,
            kota_id: this.filtered.kota_id,
            kecamatan_id: this.filtered.kecamatan_id,
            kelurahan_id: this.filtered.kelurahan_id,
            is_sipol: this.filtered.sipol,
            kategori_id: this.filtered.kategori
          }
        })
        .catch(e => e);
      // } else {
      //   this.$error("Anda harus memilih Kecamatan untuk unduh data anggota");
      // }
    },
    cetakZIP() {
      var token = lc.getItem(TOKEN);
      // return this.$store
      //   .dispatch("warga/previewZIP", {
      //     params: {
      //       access_token: token,
      //       // propinsi_id: this.filtered.propinsi_id,
      //       // kota_id: this.filtered.kota_id,
      //       // kecamatan_id: this.filtered.kecamatan_id,
      //       // kelurahan_id: this.filtered.kelurahan_id,
      //       // kategori_id: this.filtered.kategori,
      //       // is_sipol: this.filtered.sipol,
      //       role_id: this.peran,
      //       propinsi_id: this.filtered.propinsi_id,
      //       kota_id: this.filtered.kota_id,
      //       kecamatan_id: this.filtered.kecamatan_id,
      //       kelurahan_id: this.filtered.kelurahan_id,
      //       status_kta: this.filtered.status_kta,
      //       order: this.filtered.tanggal,
      //       is_sipol: this.filtered.sipol,
      //       kategori_id: this.filtered.kategori,
      //       is_sampling: this.filtered.is_sampling,
      //       validasi_lindungi_hak_mu: this.filtered.validasi_lindungi_hak_mu,
      //       is_daftar: this.filtered.is_daftar,
      //       jumlah_terdaftar: this.filtered.status_pendaftaran,
      //       is_sampling_kpu: this.filtered.is_sampling_kpu,
      //       is_unggahsurat: this.filtered.is_unggahsurat,
      //       preview: 1
      //     }
      //   })
      //   .then(res => {
      let paramsPreview = {
        access_token: token,
        role_id: this.peran,
        propinsi_id: this.filtered.propinsi_id,
        kota_id: this.filtered.kota_id,
        kecamatan_id: this.filtered.kecamatan_id,
        kelurahan_id: this.filtered.kelurahan_id,
        status_kta: this.filtered.status_kta,
        order: this.filtered.tanggal,
        is_sipol: this.filtered.sipol,
        kategori_id: this.filtered.kategori,
        is_sampling: this.filtered.is_sampling,
        validasi_lindungi_hak_mu: this.filtered.validasi_lindungi_hak_mu,
        is_daftar: this.filtered.is_daftar,
        jumlah_terdaftar: this.filtered.status_pendaftaran,
        is_sampling_kpu: this.filtered.is_sampling_kpu,
        is_sample_verfak_perbaikan: this.filtered.is_sample_verfak_perbaikan,
        is_ms_verfak: this.filtered.is_ms_verfak,
        is_hapus_sipol: this.filtered.is_hapus_sipol,
        is_daftar_verfak: this.filtered.is_daftar_verfak,
        is_vermin: this.filtered.is_vermin,
        is_unggahsurat: this.filtered.is_unggahsurat,
        is_lama: this.filtered.is_lama,
        is_bermasalah_2: this.filtered.is_bermasalah_2,
        is_cetak: this.filtered.is_cetak,
        preview: 1
      };
      //     this.$refs.previewzipDlg.open(res, paramsPreview);
      //   });
      this.$refs.previewzipDlg.open(paramsPreview);
    },
    cetakZIPCADANGAN() {
      var token = lc.getItem(TOKEN);
      // return this.$store
      //   .dispatch("warga/previewZIP", {
      //     params: {
      //       access_token: token,
      //       // propinsi_id: this.filtered.propinsi_id,
      //       // kota_id: this.filtered.kota_id,
      //       // kecamatan_id: this.filtered.kecamatan_id,
      //       // kelurahan_id: this.filtered.kelurahan_id,
      //       // kategori_id: this.filtered.kategori,
      //       // is_sipol: this.filtered.sipol,
      //       role_id: this.peran,
      //       propinsi_id: this.filtered.propinsi_id,
      //       kota_id: this.filtered.kota_id,
      //       kecamatan_id: this.filtered.kecamatan_id,
      //       kelurahan_id: this.filtered.kelurahan_id,
      //       status_kta: this.filtered.status_kta,
      //       order: this.filtered.tanggal,
      //       is_sipol: this.filtered.sipol,
      //       kategori_id: this.filtered.kategori,
      //       is_sampling: this.filtered.is_sampling,
      //       validasi_lindungi_hak_mu: this.filtered.validasi_lindungi_hak_mu,
      //       is_daftar: this.filtered.is_daftar,
      //       jumlah_terdaftar: this.filtered.status_pendaftaran,
      //       is_sampling_kpu: this.filtered.is_sampling_kpu,
      //       is_unggahsurat: this.filtered.is_unggahsurat,
      //       preview: 1
      //     }
      //   })
      //   .then(res => {
      let paramsPreview = {
        access_token: token,
        role_id: this.peran,
        propinsi_id: this.filtered.propinsi_id,
        kota_id: this.filtered.kota_id,
        kecamatan_id: this.filtered.kecamatan_id,
        kelurahan_id: this.filtered.kelurahan_id,
        status_kta: this.filtered.status_kta,
        order: this.filtered.tanggal,
        is_sipol: this.filtered.sipol,
        kategori_id: this.filtered.kategori,
        is_sampling: this.filtered.is_sampling,
        validasi_lindungi_hak_mu: this.filtered.validasi_lindungi_hak_mu,
        is_daftar: this.filtered.is_daftar,
        jumlah_terdaftar: this.filtered.status_pendaftaran,
        is_sampling_kpu: this.filtered.is_sampling_kpu,
        is_sample_verfak_perbaikan: this.filtered.is_sample_verfak_perbaikan,
        is_ms_verfak: this.filtered.is_ms_verfak,
        is_hapus_sipol: this.filtered.is_hapus_sipol,
        is_daftar_verfak: this.filtered.is_daftar_verfak,
        is_vermin: this.filtered.is_vermin,
        is_unggahsurat: this.filtered.is_unggahsurat,
        is_lama: this.filtered.is_lama,
        is_bermasalah_2: this.filtered.is_bermasalah_2,
        is_cetak: this.filtered.is_cetak,
        preview: 1
      };
      //     this.$refs.previewzipDlg.open(res, paramsPreview);
      //   });
      this.$refs.previewzipCdg.open(paramsPreview);
    },
    cetakExcellKategori() {
      var token = lc.getItem(TOKEN);
      // if (this.filtered.kecamatan_id) {
      return this.$store
        .dispatch("warga/downloadKategoriXls", {
          params: {
            access_token: token,
            propinsi_id: this.filtered.propinsi_id,
            kota_id: this.filtered.kota_id,
            kecamatan_id: this.filtered.kecamatan_id,
            kelurahan_id: this.filtered.kelurahan_id,
            is_sipol: this.filtered.sipol,
            kategori_id: this.filtered.kategori
          }
        })
        .catch(e => e);
      // } else {
      //   this.$error("Anda harus memilih Kecamatan untuk unduh data anggota");
      // }
    },
    toDowload() {
      var token = lc.getItem(TOKEN);
      // if (this.filtered.kecamatan_id) {
      return this.$store
        .dispatch("laporan/download", {
          params: {
            access_token: token,
            propinsi_id: this.filtered.propinsi_id,
            kota_id: this.filtered.kota_id,
            kecamatan_id: this.filtered.kecamatan_id,
            kelurahan_id: this.filtered.kelurahan_id,
            page: this.cp,
            s: this.textSearch,
            role_id: this.peran,
            status_kta: this.filtered.status_kta,
            order: this.filtered.tanggal,
            is_sipol: this.filtered.sipol,
            kategori_id: this.filtered.kategori,
            is_sampling: this.filtered.is_sampling,
            validasi_lindungi_hak_mu: this.filtered.validasi_lindungi_hak_mu,
            is_daftar: this.filtered.is_daftar,
            jumlah_terdaftar: this.filtered.status_pendaftaran,
            is_sampling_kpu: this.filtered.is_sampling_kpu,
            is_sample_verfak_perbaikan: this.filtered.is_sample_verfak_perbaikan,
            is_ms_verfak: this.filtered.is_ms_verfak,
            is_hapus_sipol: this.filtered.is_hapus_sipol,
            is_daftar_verfak: this.filtered.is_daftar_verfak,
            is_vermin: this.filtered.is_vermin,
            is_unggahsurat: this.filtered.is_unggahsurat,
            is_lama: this.filtered.is_lama,
            is_bermasalah_2: this.filtered.is_bermasalah_2,
            is_cetak: this.filtered.is_cetak
          }
        })
        .catch(e => e);
      // } else {
      //   this.$error("Anda harus memilih Kecamatan untuk unduh data anggota");
      // }
    },
    filter(data) {
      this.filtered = data;
      this.load();
    },
    toCetakMasal() {
      if (this.filtered.kecamatan_id) {
        this.$confirm(
          `Apakah Anda yakin akan mencetak KTA KTP Kecamatan terpilih ?<br>

      `,
          {
            range: true
          }
        ).then(res => this.$store.dispatch("warga/cetakMasal", { obj: res, kecamatan_id: this.filtered.kecamatan_id }).catch(e => e));
      } else {
        this.$error("Silakan pilih Kecamatan terlebih dahulu");
      }
    },
    ajukan(item) {
      this.$confirm(
        `Apakah Anda yakin akan mempublikasikan Anggota ini ?<br>
        <div class="mt-2 title grow text-center">
           ${item.judul} <br>
        </div>
      `
      )
        .then(() =>
          this.$store
            .dispatch("warga/ajukan", { obj: item })
            .then(() => {
              this.$info("Data berhasil diajukan");
            })
            .then(() => this.load())
            .catch(e => e)
        )
        .catch(e => e);
    },
    unggah(item) {
      this.$confirm(
        `Apakah Anda yakin akan mempublikasikan Anggota ini ?<br>
        <div class="mt-2 title grow text-center">
           ${item.judul} <br>
        </div>
      `
      )
        .then(() =>
          this.$store
            .dispatch("warga/ajukan", { obj: item })
            .then(() => {
              this.$info("Data berhasil diajukan");
            })
            .then(() => this.load())
            .catch(e => e)
        )
        .catch(e => e);
    },
    setOpsiSwitch() {
      this.$confirm(
        `Apakah Anda akan menampilkan semua data `+ (this.current_user.lingkup.is_hidden?``:`verfikasi faktual perbaikan`) +`?<br>
      `
      )
        .then(() =>
          this.$store
            .dispatch("warga/setOpsi", this.opsiSwitch)
            .then(() => {
              this.$store
                .dispatch("user/fetchOne", this.opsiSwitch).then(() => {
                this.opsiSwitch = this.current_user.lingkup.is_hidden
                this.load()
                })
              })
            .catch(e => e)
        )
        .catch(e => e);
    },
    cetakKTA(item) {
      this.$confirm(
        `Apakah Anda yakin akan mencetak KTA ?<br>
        <div class="mt-2 title grow text-center">
           ${item.nama} <br>
        </div>
      `
      )
        .then(() =>
          this.$store
            .dispatch("warga/cetak", item.id)
            .then(() => {
              // this.$info("Data berhasil diajukan");
            })
            .then(() => this.load())
            .catch(e => e)
        )
        .catch(e => e);
    },
    cetakGAMBAR(item, jenis) {
      this.$confirm(
        `Apakah Anda yakin akan mencetak Gambar KTA ?<br>
        <div class="mt-2 title grow text-center">
           ${item.nama} <br>
        </div>
      `
      )
        .then(() => {
          if (jenis == 1) {
            this.$store
              .dispatch("warga/cetakGambarDepan", item.id)
              .then(() => {})
              .then(() => this.load())
              .catch(e => e);
          } else {
            this.$store
              .dispatch("warga/cetakGambarBelakang", item.id)
              .then(() => {})
              .then(() => this.load())
              .catch(e => e);
          }
        })
        .catch(e => e);
    },

    getDetil(item) {
      this.$refs.detailDlg.open(item);
    },
    add() {
      this.$refs.dlg.open().then(() => {
        this.load();
      });
    },
    konfirmasiUnggah() {
      if (this.filtered.kota_id) {
        this.$refs.unggahDlg.open(this.filtered.kota_id).then(() => {
          this.load();
        });
      } else {
        this.$error("Pilih Filter Kota terlebih dahulu");
      }
    },
    previewKTA(item) {
      this.$refs.previewDlg.open(item).then(() => {
        this.load();
      });
    },
    previewCustom(items, range, kota_id) {
      this.$refs.previewCustomDlg.open(items, range, kota_id).then(() => {
        this.load();
      });
    },
    edit(item) {
      this.$refs.dlg.open(item).then(() => {
        this.load();
      });
    },
    link(item) {
      window.open(item.link, "_blank");
    },
    hapus(item) {
      this.$confirm(
        `Apakah Anda yakin akan menghapus data warga ini ?<br>
        <div class="mt-2 title grow text-center">
          ${item.nama}<br>
        </div>`,
        {
          cancelOnly: item.laporan_accepted_count > 0 ? true : false
        }
      )
        .then(() => this.$store.dispatch("warga/drop", item))
        .then(() => {
          this.$info("Data Anggota " + item.nama + " berhasil dihapus");
        })
        .then(() => this.load())
        .catch(e => e);
    }
  },
  watch: {
  }
};
</script>
